import {sanitiseForUI} from '../utils/sanitise-for-ui'
import {ActionFlowState} from './slice/flow/state'

export type State = {
  flow: ActionFlowState
}

export const getInitialState = (
  flow: ActionFlowState,
  {segmentIds}: {segmentIds?: string[]}
): State => ({
  flow: {
    ...flow,
    config: sanitiseForUI(flow.config, {segmentIds})
  }
})

export type UndoRedoState = {
  past: State[]
  present: State
  future: State[]
}

export const getInitialUndoRedoState = (state: State): UndoRedoState => ({
  past: [],
  present: state,
  future: []
})
